import DOMPurify from 'dompurify';
import type { DiffViewProps } from './components.types';
import { diffContainerClasses } from './summaryQuality.styles';

// transcriber_db's inline diff uses only <span class="diff-added|diff-removed"> and a
// <p class="diff-empty"> placeholder around html-escaped text; anything else is dropped.
const DIFF_SANITIZE_CONFIG = { ALLOWED_TAGS: ['span', 'p'], ALLOWED_ATTR: ['class'] };

export const sanitizeDiffHtml = (html: string) => DOMPurify.sanitize(html, DIFF_SANITIZE_CONFIG);

export const DiffView = ({ html }: DiffViewProps) => (
  <div
    className={diffContainerClasses}
    // biome-ignore lint/security/noDangerouslySetInnerHtml: only DOMPurify output with a span/p allow-list is rendered
    dangerouslySetInnerHTML={{ __html: sanitizeDiffHtml(html) }}
  />
);
